import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const defaultPermissions = {
  isAdmin: false,
  canRead: false,
  toDownload: false,
  toAddMaid: false,
  toDeleteMaid: false,
  viewAttendants: false,
  viewValets: false,
  viewBellmans: false,
  viewAirbnb: false,
  adminServiceMaids: false,
  adminServiceValets: false,
  adminServiceBellmen: false,
  adminServiceAirbnb: false,
};

const usePermissions = () => {
  const { user } = useSelector((state) => state.userDetails);
  const [permissions, setPermissions] = useState(defaultPermissions);

  useEffect(() => {
    if (!user) return;

    const updatedPermissions = {
      ...defaultPermissions,
      isAdmin: user?.isAdmin,
      canRead: user?.roles?.permissions?.read || false,
      toDownload: user?.roles?.permissions?.download || false,
      toAddMaid: user?.roles?.permissions?.addMaid || false,
      toDeleteMaid: user?.roles?.permissions?.deleteMaid || false,
      viewAttendants: user?.isAdmin
        ? user?.services?.maids
        : user?.roles?.permissions?.viewAttendants || false,
      viewValets: user?.isAdmin
        ? user?.services?.valets
        : user?.roles?.permissions?.viewValets || false,
      viewBellmans: user?.isAdmin
        ? user?.services?.bellmen
        : user?.roles?.permissions?.viewBellmans || false,
      viewAirbnb: user?.isAdmin
        ? user?.services?.airbnb
        : user?.roles?.permissions?.viewAirbnb || false,
    };

    setPermissions((prev) =>
      JSON.stringify(prev) !== JSON.stringify(updatedPermissions)
        ? updatedPermissions
        : prev
    );
  }, [user]);

  const hasPermission = (perm) => {
    if (permissions.isAdmin) return true;
    return Boolean(permissions[perm]);
  };

  return { ...permissions, hasPermission };
};

export default usePermissions;
